import React from "react";

import NewCreateCollection from "./../../components/NewCreateCollection/NewCreateCollection.component";

const CreateCollectionPage = () => {
  return <NewCreateCollection />;
};

export default CreateCollectionPage;
